/*
 *   Copyright (c) 2022 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import _ from "lodash";
import { VApplication } from "../application";
import { GraphqlServerModule } from '@vlinder-web/graphql-server-module-react';
import { ADDITIONAL_INFO_SUBMITTED, GET_APPLICATION_BY_ID_FOR_USER } from "../pages/UpdateEpccApplication/graphql";
import { toast } from "react-hot-toast"

const MODULE_NAME = "ApplicationFormService";
const log: any = LoggerModule.getInstance();

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync('services.GraphqlServerModule') as GraphqlServerModule;
};

export class UpdateApplicationFormService {
    private static instance: UpdateApplicationFormService;
    private vapp: VApplication;
    // private termsURL: string;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        // this.termsURL = props?.termsURL
    }
    public static getInstance(props: any = {}): UpdateApplicationFormService {
        if (!UpdateApplicationFormService.instance) {
            UpdateApplicationFormService.instance = new UpdateApplicationFormService(props);
        }
        return UpdateApplicationFormService.instance;
    }

    async  updateApplicationById(props:any) {
        console.log("updateApplicationById-->",props);
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }

        try {
            if (client) {
                const res = await client.mutate({
                    mutation: ADDITIONAL_INFO_SUBMITTED,
                    variables: {
                        applicationId: props?.applicationId,
                        data:props?.input
                    },

                    fetchPolicy: "no-cache",
                });
                console.log("updateApplicationById", res?.data);
                //log.success(MODULE_NAME, "editApplicationForm : ", res?.data);
                if (res) {
                    return res?.data;
                }
            }
        } catch (err: any) {
            console.log(err)
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }

    async  getApplicationById(props:any) {
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        if(!client){
            console.log('graphql-gateway is not available !!!!!!');
        }
        try {
            if (client) {
                const res = await client.query({
                    query: GET_APPLICATION_BY_ID_FOR_USER,
                    variables:{applicationId:props?.applicationId},
                    fetchPolicy: "network-only",
                });
                if (res) {
                    return res?.data?.getApplicationbyIdForUser;
                }
            }
        } catch (err: any) {
            console.log(err)
            err?.graphQLErrors &&
                Array.isArray(err?.graphQLErrors) &&
                err?.graphQLErrors.length > 0 &&
                toast.error(err?.graphQLErrors[0]?.message);
        }
    }
}
